import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button} from "reactstrap";

class PromoVideoUrlList extends Component {

    renderUrl = url => (
            <section>
                <div className="promo_video_folder_row">
                    <h5>{url.value}</h5>
                        <Button
                            onClick={() => this.props.changeUrlValue(url)}
                            size="sm"
                            round="true"
                            icon="true"
                            color="inverse"
                        >
                            <i className="fa fa-edit"/>
                        </Button>
                        <Button
                            onClick={event => {
                                event.stopPropagation();
                                this.props.deleteUrl(url.id)
                            }}
                            color="danger"
                            size="sm"
                            round="true"
                            icon="true"
                            className="promo_video_button_left_margin"
                        >
                            <i className="fa fa-times"/>
                        </Button>
                </div>
            </section>
    );

    render() {
        const {folderId, urls} = this.props;
        const renderList = urls
            ? urls.map((url) => this.renderUrl(url))
            : null;

        return (
            <div>
                {renderList}
                <Button
                    onClick={() => this.props.addUrl(folderId)}
                    size="sm"
                    round="true"
                    icon="true"
                    color="inverse"
                >
                    <i className="fa fa-plus"/>
                </Button>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    lang: state.languageReducer.lang
});

export default connect(mapStateToProps)(PromoVideoUrlList)


// WEBPACK FOOTER //
// ./src/components/PromoVideo/PromoVideoUrlList.js